var _path, _path2, _circle, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsdtsol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35577 2H15.8756C16.1505 2 16.4044 2.14704 16.5414 2.3856L19.8976 8.22616C20.0717 8.52905 20.02 8.91134 19.7717 9.15696L10.5337 18.2967C10.2344 18.5928 9.75307 18.5928 9.45381 18.2967L0.228291 9.1693C-0.0257343 8.91798 -0.073302 8.52455 0.113496 8.21976L3.701 2.36686C3.84072 2.13892 4.08865 2 4.35577 2ZM14.3882 4.60761V6.2464H11.1066V7.3826C13.4114 7.50403 15.1405 8.00271 15.1533 8.60044L15.1533 9.84655C15.1404 10.4443 13.4114 10.943 11.1066 11.0644V13.8528H8.92764V11.0644C6.6229 10.943 4.89375 10.4443 4.88095 9.84655L4.88099 8.60044C4.89383 8.00271 6.6229 7.50403 8.92764 7.3826V6.2464H5.6461V4.60761H14.3882ZM10.0171 10.2083C12.4767 10.2083 14.5325 9.78664 15.0355 9.22351C14.6089 8.74598 13.0657 8.37013 11.1066 8.26691V9.45654C10.7555 9.47504 10.391 9.48479 10.0171 9.48479C9.64328 9.48479 9.27879 9.47504 8.92764 9.45654V8.26691C6.96852 8.37013 5.42534 8.74598 4.99871 9.22351C5.5018 9.78664 7.55758 10.2083 10.0171 10.2083Z",
    fill: "#009393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3882 4.60761V6.2464H11.1066V7.38261C13.4114 7.50403 15.1405 8.00271 15.1534 8.60044L15.1533 9.84655C15.1405 10.4443 13.4114 10.943 11.1066 11.0644V13.8528H8.92767V11.0644C6.62293 10.943 4.89378 10.4443 4.88098 9.84655L4.88102 8.60044C4.89386 8.00271 6.62293 7.50403 8.92767 7.38261V6.2464H5.64613V4.60761H14.3882ZM15.0356 9.22352C14.5325 9.78664 12.4767 10.2083 10.0172 10.2083C7.5576 10.2083 5.50183 9.78664 4.99873 9.22352C5.42536 8.74598 6.96855 8.37013 8.92767 8.26691V9.45655C9.27882 9.47504 9.64331 9.48479 10.0172 9.48479C10.391 9.48479 10.7555 9.47504 11.1066 9.45655V8.26691C13.0658 8.37013 14.6089 8.74598 15.0356 9.22352Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 5,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9751 12.0735C13.0118 12.0264 13.0616 12 13.1135 12H17.9019C17.9891 12 18.0328 12.1352 17.9711 12.2143L17.0249 13.4266C16.9882 13.4736 16.9384 13.5 16.8865 13.5H12.0981C12.0109 13.5 11.9672 13.3648 12.0289 13.2857L12.9751 12.0735Z",
    fill: "url(#paint0_linear_6366_51755)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9751 16.5734C13.0118 16.5264 13.0616 16.5 13.1135 16.5H17.9019C17.9891 16.5 18.0328 16.6353 17.9711 16.7143L17.0249 17.9265C16.9882 17.9736 16.9384 18 16.8865 18H12.0981C12.0109 18 11.9672 17.8647 12.0289 17.7857L12.9751 16.5734Z",
    fill: "url(#paint1_linear_6366_51755)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8865 14.25C16.9384 14.25 16.9882 14.2764 17.0249 14.3234L17.9711 15.5357C18.0328 15.6148 17.9891 15.75 17.9019 15.75H13.1135C13.0616 15.75 13.0118 15.7236 12.9751 15.6765L12.0289 14.4643C11.9672 14.3853 12.0109 14.25 12.0981 14.25H16.8865Z",
    fill: "url(#paint2_linear_6366_51755)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6366_51755",
    x1: 16.0564,
    y1: 10.3463,
    x2: 11.2684,
    y2: 17.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6366_51755",
    x1: 16.0564,
    y1: 10.3463,
    x2: 11.2684,
    y2: 17.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6366_51755",
    x1: 16.0564,
    y1: 10.3463,
    x2: 11.2684,
    y2: 17.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtsol);
export default __webpack_public_path__ + "static/media/usdtsol.42177b2f377ad918e4b34aad502e3bc0.svg";
export { ForwardRef as ReactComponent };